import script from "./DuracionFormModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DuracionFormModal.vue?vue&type=script&setup=true&lang=js"

import "./DuracionFormModal.vue?vue&type=style&index=0&id=72fcd102&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72fcd102"]])

export default __exports__